import { GlowFastAccessListItem, PropsWithDataLayer } from '@headless-workspace/glow-ds';
import { Component, Image } from '@headless-workspace/typings';

type HomeFastAccessLink = PropsWithDataLayer & {
    label: string;
    subLabel?: string;
    href: string;
    image: Image;
};
type UIFastAccessListProps = {
    fastAccessLinks: HomeFastAccessLink[];
};

export const UIFastAccessList: Component<UIFastAccessListProps> = ({ fastAccessLinks }) => {
    return (
        <ul className={'flex justify-evenly px-1 py-0.75 w-full'}>
            {fastAccessLinks.map(({ label, href, image, subLabel, dataLayer }, index) => {
                return (
                    <GlowFastAccessListItem
                        image={image}
                        href={href}
                        label={label}
                        subLabel={subLabel}
                        key={`fast-access-${label}-${index}`}
                        dataLayer={dataLayer}
                    />
                );
            })}
        </ul>
    );
};
